import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/tools-for-retail")({
  beforeLoad: () => { throw redirect({ to: "/en/tools", statusCode: 301 }); },
});
